import { getFormFields } from './get-forms-fields';

const formatForRender = formSchema => {
  const newSchema = [];

  let schema = getFormFields(formSchema);

  while (schema.length > 0) {
    const field = schema.shift();
    if (field.group) {
      const inputGroup = [field];
      const others = schema.filter(f => f.group === field.group);
      inputGroup.push(...others);

      schema = schema.filter(el => !others.includes(el));

      newSchema.push({ fields: inputGroup, section: field.section });
    } else {
      newSchema.push({ fields: [field], section: field.section });
    }
  }
  return newSchema;
};

export { formatForRender };
